import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { User, UserSuperGroup } from '../user/user.model';
import { UserService } from '../user/user.service';

import { TranslationKeyMap } from './profile.i18n';

@Component({
    selector: 'cmps-profile-supergroup',
    templateUrl: './supergroup.profile.component.html',
})
export class SuperGroupProfileComponent implements OnInit, OnDestroy {
    @Input()
    user: User;

    i18n = TranslationKeyMap;
    private _translateSub: Subscription;
    hasPendingData: boolean;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly _userService: UserService,
    ) {}

    ngOnInit(): void {
        this._load();

        this._translateSub = this._translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => this._load(),
        );
    }

    ngOnDestroy(): void {
        if (this._translateSub) {
            this._translateSub.unsubscribe();
        }
    }

    private _load(): void {
        this.hasPendingData = true;
        this._userService
            .listSuperGroups(this.user.id)
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (superGroups: UserSuperGroup[]) =>
                    (this.user.superGroups = superGroups),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }
}
